import React from "react";

function NotificationSkeleton() {
  return (
    <div className="space-y-4">
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className="h-28 animate-pulse rounded-[1.5rem] bg-slate-200 dark:bg-white/10"
          />
        ))}
      </div>

      <div className="h-40 animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10" />
      <div className="h-[420px] animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10" />
    </div>
  );
}

export default NotificationSkeleton;